import { Tabs } from '../../model/model'
import dayjs from 'dayjs'
import { API_URL } from '../../constants'
import axios from 'axios';

// Getting the base URL from environment variables
const baseUrl = API_URL

const apiUrl = (url) => {
  let base = baseUrl
  if (!base) base = 'http://localhost:5173'

  return new URL(url, base)
}

// Search for odds by text query
const searchOdds = async (searchQuery) => {
  const url = apiUrl("/api/v1/odds")
  url.searchParams.append("search", encodeURIComponent(searchQuery))

  const response = await fetch(url)
  if (!response.ok) {
    throw new Error("Failed to fetch odds");
  }

  const json = await response.json();
  return json.response
}

// Main function to fetch odds from the API
const fetchOdds = async ({
  tab,
  filter,
  page,
  searchQuery,
  mode,
  selectedBet,
}) => {
  const url = apiUrl("/api/v1/odds/")
  const sp = url.searchParams

  // Generate the "market" parameter based on the selected tab and mode
  const market = buildMarketParameter(tab, filter, mode, selectedBet)
  if (market != null) {
    sp.append("market", market)
  }

  if (searchQuery) {
    sp.append("search", searchQuery)
  } else if (mode === 'filter') {

    sp.append("fixture_date_on", buildStartDate(filter))
    if (filter.countries.length > 0) {
      sp.append("country", filter.countries.join(','))
    }
    if (filter.league.length > 0) {
      sp.append("league", filter.league.join(','))
    }
    if (filter.bookmakers.length > 0) {
      sp.append("bm", filter.bookmakers.join(','))
    }
    appendMarketValuesIfNeeded(sp, filter)

    if (filter.oddsValue.enabled) {
      sp.append("odd_min", filter.oddsValue.min)
      sp.append("odd_max", filter.oddsValue.max)
    }
  } else if (mode === 'selectedBet') {
    appendMarketValuesIfNeeded(sp, filter)
    sp.append("fixture", selectedBet.fixtureId)
    
  } else {
    sp.append("fixture_date_on", buildStartDate(filter))
    sp.append("fixture_date_end", buildEndDate(filter))
  }

  if (page != null && page > 1) {
    sp.append("page", page)
  }

  const token = localStorage.getItem('token')
  console.log('Req Url: ', url)
  let response = null


  if (token === null) {
    response = await axios.get(url);
  } else {
    try {
      response = await axios.get(url, {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });
    } catch {
      response = await axios.get(url);
    }
  }

  const json = await response.data;
  const data = json.response

  return data
}

// Function that returns the value market
const buildMarketParameter = (tab, filter, mode, selectedBet) => {
  let result = []
  const m = filter.markets
  if (mode === 'filter' || mode === 'selectedBet') {
    if (tab === Tabs.FullTime) {
      if (m.checkBoxWinner) {
        result.push('1')
      }
      if (m.checkBoxDc) {
        result.push('12')
      }
      if (m.over_goals.length > 0 || m.under_goals.length > 0) {
        result.push('5')
      }
    } else if (tab === Tabs.FirstHalf) {
      if (m.checkBoxWinner) {
        result.push('13')
      }
      if (m.checkBoxDc) {
        result.push('20')
      }
      if (m.over_goals.length > 0 || m.under_goals.length > 0) {
        result.push('6')
      }
    } else if (tab === Tabs.SecondHalf) {
      if (m.checkBoxWinner) {
        result.push('3')
      }
      if (m.checkBoxDc) {
        result.push('33')
      }
      if (m.over_goals.length > 0 || m.under_goals.length > 0) {
        result.push('26')
      }
    }
  } else {
    if (tab === Tabs.FullTime) {
      result.push('1')
    } else if (tab === Tabs.FirstHalf) {
      result.push('13')
    } else if (tab === Tabs.SecondHalf) {
      result.push('3')
    }
  }
  if (result.length > 0) return result.join(",")
  else return undefined
}

// Add "Over" and "Under" parameters to the request if they exist
const appendMarketValuesIfNeeded = (sp, filter) => {
  const overGoals = filter.markets.over_goals
  const underGoals = filter.markets.under_goals
  if (overGoals.length === 0 && underGoals.length === 0) return

  for (const v of overGoals) {
    sp.append('value', `Over ${v}`)
  }
  for (const v of underGoals) {
    sp.append('value', `Under ${v}`)
  }
}

// Function to get the filter start date
const buildStartDate = (filter) => {
  return formatDate(dayjs(filter.date))
}

// Function to get the filter end date (adds one day)
const buildEndDate = (filter) => {
  return formatDate(dayjs(filter.date).add(1, 'day'))
}

const formatDate = (date) => {
  return date.format('YYYY-MM-DD')
}

export {
  fetchOdds, searchOdds,
}